import { Communicator } from "./databin$"
import { CoordinatorService } from "./coordinator.service"
import { BehaviorSubject, Subject } from "rxjs"
import { XItem } from "./x-item"


class Channel {
    isOn = false
    tag: string;
    title: string;
    description: string;
    url: string;

    constructor(private coords: CoordinatorService, params: any) {
        this.tag = params.tag;
        this.title = params.title;
        this.description = params.description;
        this.url = params.url;
    }
}

export class RssCommunicator  implements Communicator {
    // buttonCommunicator$ = new Subject()
    tag = "rss"
    update$ = new Subject<void>()
    itmLs: Object[] = []

    message$ = new BehaviorSubject<string>("")
    xitemLs$ = new BehaviorSubject<XItem[]>([])

    channelLs: Channel[] = []

    constructor(public coords: CoordinatorService) {
        this.coords.template$.repository$.rssChannelLs.forEach(channel => {
            const ch = new Channel(coords, channel)
            this.channelLs.push(ch)
        })
    }

    get connection() {
        return this.coords.databin$.editedConnection$.getValue()!
    }

    // async confirm() {
    //     this.connection.readParserList(this.itmLs)
    //     await this.connection.finalize()
    //     this.update$.next()
    // }
}
